import React, { Fragment, useContext } from 'react';
// We have deprecated unstated. Please use react-sweet-state instead
// eslint-disable-next-line no-restricted-imports
import { Subscribe } from 'unstated';

import { CreateDialogContext } from '@confluence/create-dialog-context';

import { ErrorBoundary } from '@confluence/error-boundary';
import { FlagsStateContainer } from '@confluence/flags';
import { withAnalyticsEvents } from '@atlaskit/analytics-next';
import { VariableInputDrawerComponent } from './VariableInputDrawerComponent';

const VariableInputDrawer = ({ createAnalyticsEvent }: any) => {
	const {
		contentId,
		spaceKey,
		parentPageId,
		templateId,
		title,
		showTemplateVariableInputDrawer,
		onClose,
		onContentUpdated,
		beforeUpdateRequest,
		onError,
		forceTemplatePanelOpen,
		openContentInNewTab,
	} = useContext(CreateDialogContext);

	return (
		<ErrorBoundary attribution="fabric">
			<Subscribe to={[FlagsStateContainer]}>
				{(flags: FlagsStateContainer) => (
					<Fragment>
						{templateId ? (
							<VariableInputDrawerComponent
								isOpen={showTemplateVariableInputDrawer}
								spaceKey={spaceKey}
								parentPageId={parentPageId}
								templateId={templateId}
								title={title}
								onClose={onClose}
								flags={flags}
								createAnalyticsEvent={createAnalyticsEvent}
								contentId={contentId}
								onContentUpdated={onContentUpdated}
								beforeUpdateRequest={beforeUpdateRequest}
								forceTemplatePanelOpen={forceTemplatePanelOpen}
								openContentInNewTab={openContentInNewTab}
								onError={onError}
							/>
						) : null}
					</Fragment>
				)}
			</Subscribe>
		</ErrorBoundary>
	);
};

export default withAnalyticsEvents()(VariableInputDrawer);
